import type { Translation } from "./strings";

export default {
  history: "Hörverlauf",
  history_all_time: "Gesamter Zeitraum",
  history_calendar: "Kalender",
  history_daily: "Täglicher Hörverlauf für {noise}",
  history_back: "Zurück zu allen Klängen",
  history_sound: "Klang",
  history_all_time_empty: "Noch nichts aufgezeichnet.",
  history_minutes: "Gespielte Minuten",
  history_date: "Datum",
  history_previous: "Vorherige Woche",
  history_next: "Nächste Woche",
  history_today: "Heute",
  history_empty: "Für diesen Zeitraum wurde nichts aufgezeichnet.",
  history_local: "Auf diesem Gerät gespeichert. Die laufende Wiedergabe wird alle 15 Sekunden aktualisiert.",
  history_storage_failed: "Ein Teil des Hörverlaufs konnte nicht geladen oder gespeichert werden.",
  history_value: "{noise}: {minutes} Min.",

  widget_description: "Jeden Klang mit einem Tippen starten und stoppen.",
  noise_white_title: "Weißes Rauschen",
  noise_pink_title: "Rosa Rauschen",
  noise_brown_title: "Braunes Rauschen",
  noise_fan_title: "Ventilator",
  noise_waves_title: "Meereswellen",
  noise_white_short: "Weiß",
  noise_pink_short: "Rosa",
  noise_brown_short: "Braun",
  noise_fan_short: "Ventilator",
  noise_waves_short: "Wellen",
  noise_white_blurb: "Gleiche Energie auf allen Frequenzen. Hell und klar.",
  noise_pink_blurb: "Sanftere Höhen, tiefere Bässe. Wie gleichmäßiger Regen.",
  noise_brown_blurb: "Vor allem Bässe, gedämpfte Höhen. Ein tiefes, weiches Grollen.",
  noise_fan_blurb: "Ein gleichmäßiger Luftstrom über einem tiefen Brummen.",
  noise_waves_blurb: "Brandung, die heranrollt und ausläuft, nie zweimal gleich.",
  status_audio_failed: "Dieser Browser konnte die Wiedergabe nicht starten.",
  play_noise: "{noise} abspielen",
  stop_noise: "{noise} stoppen",
  stop: "Stopp",
  language: "Sprache",
  language_device: "Gerätesprache",
  language_storage_failed: "Dieser Browser konnte Ihre Sprache nicht speichern. Sie wird zurückgesetzt, wenn Sie diese Seite schließen.",
  volume: "Lautstärke",
  more: "Mehr",
  playback_log: "Wiedergabeprotokoll",
  playback_log_local: "Die letzten 300 Ereignisse bleiben auf diesem Gerät. Es wird nichts gesendet, es sei denn, du teilst das Protokoll. Die Details enthalten Diagnosecodes des Systems.",
  playback_log_empty: "Noch keine Wiedergabeereignisse aufgezeichnet.",
  playback_log_storage_failed: "Einige Wiedergabeereignisse konnten nicht geladen oder gespeichert werden.",
  playback_log_share: "Protokoll teilen",
  playback_log_save: "Protokoll speichern",
  playback_log_share_failed: "Das Protokoll konnte nicht geteilt werden. Versuche, es stattdessen zu speichern.",
  log_play_requested: "Wiedergabe angefordert",
  log_stop_requested: "Stopp angefordert",
  log_started: "Wiedergabe gestartet",
  log_stopped: "Wiedergabe gestoppt",
  log_focus_changed: "Audiofokus geändert",
  log_focus_denied: "Audiofokus verweigert",
  log_noisy: "Audioausgabe getrennt",
  log_task_removed: "App aus der Übersicht entfernt",
  log_engine_failed: "Audio-Engine fehlgeschlagen",
  log_service_destroyed: "Wiedergabedienst beendet",
  log_process_exit: "System hat ein Prozessende während der Wiedergabe aufgezeichnet",
  log_unclean_exit: "Für die vorherige Wiedergabe wurde kein Stopp aufgezeichnet; die Ursache ist unbekannt.",
  log_interruption: "Unterbrechung der Audiositzung",
  log_route_changed: "Audioausgabe geändert",
  log_configuration_changed: "Konfiguration der Audio-Engine geändert",
  log_termination: "App wird beendet",
  log_context_state: "Status des Audiokontexts geändert",
  log_worklet_error: "Audio-Worklet fehlgeschlagen",
  log_visibility: "Seitensichtbarkeit geändert",
  log_page_hidden: "Seite geschlossen oder verlassen",
  log_media_error: "Medienwiedergabe fehlgeschlagen",
  settings: "Einstellungen",
  settings_general: "Allgemein",
  appearance: "Erscheinungsbild",
  appearance_system: "System",
  appearance_light: "Hell",
  appearance_dark: "Dunkel",
  appearance_storage_failed: "Dieser Browser konnte dein Erscheinungsbild nicht speichern. Es wird zurückgesetzt, wenn du diese Seite schließt.",
  rate_app: "App bewerten",
  about: "Info",
  about_version: "Version {version} ({build})",
  about_site_version: "Version {version}",
  about_also_android_web: "Auch für {android} und im {web} erhältlich.",
  about_also_ios_web: "Auch für {ios} und im {web} erhältlich.",
  about_also_ios_android: "Auch für {ios} und {android} erhältlich.",
  platform_web: "Web",
  close: "Schließen",
  notification_channel_name: "Wiedergabe",
  intent_noise: "Rauschen",
  intent_play_title: "Rauschen abspielen",
  intent_play_description: "Spielt einen der Klänge ab.",
  intent_stop_title: "Rauschen stoppen",
  intent_stop_description: "Stoppt die Wiedergabe.",
  support: "Support",
  privacy_policy: "Datenschutzerklärung",
  web_title: "Generator für weißes, rosa und braunes Rauschen",
  review_title: "Android-Hintergrundwiedergabe",
  review_intro: "Diese Aufnahme zeigt, wie vom Nutzer gestartetes Audio weiterläuft, während Noise Connoisseur im Hintergrund ist. Schalten Sie den Ton ein, um die Wiedergabe zu hören.",
  review_start: "In der App auf „Play White Noise“ (Weißes Rauschen abspielen) tippen.",
  review_background: "Zum Startbildschirm zurückkehren und die Benachrichtigungen öffnen. Weißes Rauschen läuft weiter; die Mediensteuerung ist sichtbar.",
  review_stop: "In der Benachrichtigung auf „Pause“ tippen. Der Ton stoppt; nach der Rückkehr zur App ist die Wiedergabe angehalten.",
  review_capture: "Aufgenommen auf einem Android-Emulator mit einer APK, die aus dem Release-App-Bundle erstellt und für lokale Tests signiert wurde. Die Aufnahme enthält den Geräteton.",
  review_build: "Version (Build)",
  review_recorded: "Aufgenommen",
  review_download: "Video herunterladen",
  review_details: "Aufnahmedetails",
} satisfies Translation;
